import moment from "moment";
import { Link } from "react-router-dom";
import IconDropdown from "../../../components/common/IconDropdown";
import Success from "../../../assets/icons/Success";

interface IMyProjects {
    handleDropdown: (
        selectedValue: string,
        record: { [key: string]: string | boolean | number | undefined }
    ) => void;
    pinCount: number;
    iconDropdownOptions?: any;
    handleNavigate?: any;
    customerEnabled?: boolean | undefined;
    iconDropdownOptionsForCustomer?: any;
}

interface IOtherProjects {
    handleDropdown: (
        selectedValue: string,
        record: { [key: string]: string | boolean | number | undefined }
    ) => void;
    pinCount: number;
    iconDropdownOptions?: any;
    handleNavigate?: any;
}

export const myProjects = ({ handleDropdown, pinCount, iconDropdownOptions, handleNavigate }: IMyProjects) =>
    [
        {
            title: "Project name",
            dataIndex: "ProjectName",
            key: "projectName",
            sortable: true,
            width: "10%",
            render: (_: string, record: { projectName: string; projectID: string }) => (
                <Link to={`/project-details/projectID=${record?.projectID}`} onClick={() => handleNavigate(record)}>
                    <p className="text-[14px] font-normal text-primary-400 cursor-pointer truncate hover:underline focus:underline active:underline">
                        {record?.projectName}
                    </p>
                </Link>
            ),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            sortable: true,
            width: "10%",
            minwidth: "10rem",
            render: (_: string, record: { projectName: string; projectID: string, status: number }) => {
                return (
                    <div>
                        {
                            record?.status === 0 ?
                                <div className="border text-center border-gray-200 rounded px-2 py-1 text-gray-200">
                                    In progress
                                </div>
                                : record?.status === 1 ?
                                    <div className="border flex items-center justify-center text-center border-success-400 rounded px-2 py-1 text-success-400" >
                                        <Success size={12} color="#32D583" className="ml-1 text-success-400 mr-1" />
                                        Acknowledged
                                    </div >
                                    : record?.status === 2 ?
                                        <div className="border text-center border-lightorange-500 rounded px-2 py-1 text-lightorange-500" >
                                            Need review
                                        </div>
                                        : record?.status === 3 ?
                                            <div className="border text-center border-darkblue-400 rounded px-2 py-1 text-darkblue-400" >
                                                Review In-progress
                                            </div >
                                            : record?.status === 4 &&
                                            <div className="border text-center rounded px-2 py-1 text-primary-400 border-primary-400">
                                                Customer ready
                                            </div>
                        }
                    </div>
                )
            },
        },
        {
            title: "Well name",
            dataIndex: "WellName",
            key: "wellName",
            sortable: true,
            width: "8%",
        },
        {
            title: "Company name",
            dataIndex: "CompanyName",
            key: "companyName",
            sortable: true,
            width: "8%",
        },
        {
            title: "Type",
            dataIndex: "liftTypeName",
            key: "liftTypeName",
            sortable: true,
            width: "8%",
            minwidth: "10rem",
            render: (_: string, record: { caseNameList: any[]; }) => {
                const parentLiftType = record?.caseNameList?.[0]?.liftType;
                const espType = record?.caseNameList?.find((type: any) => type?.liftType === 1);
                const jetType = record?.caseNameList?.find((type: any) => type?.liftType === 2);
                let liftTypeName = <></>;
                if (espType && jetType) {
                    liftTypeName = <>
                        {parentLiftType === 1 ? (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>
                            </>) : (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>
                            </>
                        )}
                    </>;
                } else if (jetType) {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>;
                } else {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>;
                }
                return (
                    <div>
                        {liftTypeName}
                    </div >
                )
            },
        },
        {
            title: "Created on",
            dataIndex: "CreatedOn",
            key: "createdOn",
            sortable: true,
            width: "8%",
            render: (_: string, record: { createdOn: string }) => (
                <>
                    {record?.createdOn && moment(record?.createdOn).format("DD MMM YYYY")}
                </>
            ),
        },
        {
            title: "Updated on",
            dataIndex: "UpdatedOn",
            key: "updatedOn",
            sortable: true,
            width: "8%",
            render: (_: string, record: { updatedOn: string }) => (
                <>
                    {record?.updatedOn && moment(record?.updatedOn).format("DD MMM YYYY")}
                </>
            ),
        },
        {
            title: "Country",
            dataIndex: "Country",
            key: "country",
            sortable: true,
            width: "8%",
        },
        {
            title: "State",
            dataIndex: "State",
            key: "state",
            sortable: true,
            width: "8%",
        },
        {
            title: "Account manager",
            dataIndex: "DALRep",
            key: "dalRep",
            sortable: true,
            width: "8%",
        },
        {
            title: "Unit system",
            dataIndex: "UnitSystem",
            key: "unitSystem",
            sortable: true,
            width: "8%",
        },
        {
            title: " ",
            dataIndex: "icon",
            key: "icon",
            sortable: false,
            width: "5%",
            render: (_: string, record: { isPinned: boolean }, rowIndex: number) => {
                const dropdownOptions = iconDropdownOptions.map((option: any, index: any) => {
                    if (index === 0) {
                        return {
                            ...option,
                            disabled: pinCount === 5 || record?.isPinned ? true : false,
                        };
                    }
                    return option;
                });

                return (
                    <div className="flex items-center px-0 py-0">
                        <IconDropdown
                            options={dropdownOptions}
                            onSelect={(selectedValue) => handleDropdown(selectedValue, record)}
                            optionHeading={"Options"}
                            dropdownIcon={true}
                            width="320px"
                            rowIndex={rowIndex}
                        />
                    </div>
                );
            },
        },
    ];


export const myProjectsCustomer = ({ handleDropdown, pinCount, iconDropdownOptions, handleNavigate, iconDropdownOptionsForCustomer }: IMyProjects) =>
    [
        {
            title: "Well name",
            dataIndex: "WellName",
            key: "wellName",
            sortable: true,
            width: "8%",
        },
        {
            title: "Project",
            dataIndex: "ProjectName",
            key: "projectName",
            sortable: true,
            width: "10%",
            render: (_: string, record: { projectName: string; projectID: string }) => (
                <Link to={`/project-details/projectID=${record?.projectID}`} onClick={() => handleNavigate(record)}>
                    <p className="text-[14px] font-normal text-primary-400 cursor-pointer truncate hover:underline focus:underline active:underline">
                        {record?.projectName}
                    </p>
                </Link>
            ),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            sortable: true,
            width: "10%",
            minwidth: "10rem",
            render: (_: string, record: { projectName: string; projectID: string, status: number }) => {
                return (
                    <div>
                        {
                            record?.status === 0 ?
                                <div className="border text-center border-gray-200 rounded px-2 py-1 text-gray-200">
                                    In progress
                                </div>
                                : record?.status === 1 ?
                                    <div className="border flex items-center justify-center text-center border-success-400 rounded px-2 py-1 text-success-400" >
                                        <Success size={12} color="#32D583" className="ml-1 text-success-400 mr-1" />
                                        Acknowledged
                                    </div >
                                    : record?.status === 2 ?
                                        <div className="border text-center border-lightorange-500 rounded px-2 py-1 text-lightorange-500" >
                                            Need review
                                        </div >
                                        : record?.status === 3 ?
                                            <div className="border text-center border-darkblue-400 rounded px-2 py-1 text-darkblue-400" >
                                                Review In-progress
                                            </div >
                                            : record?.status === 4 &&
                                            <div className="border text-center rounded px-2 py-1 text-primary-400 border-primary-400">
                                                Customer ready
                                            </div>
                        }
                    </div>
                )
            },
        },
        {
            title: "Type",
            dataIndex: "liftTypeName",
            key: "liftTypeName",
            sortable: true,
            width: "8%",
            minwidth: "10rem",
            render: (_: string, record: { caseNameList: any[]; }) => {
                const parentLiftType = record?.caseNameList?.[0]?.liftType;
                const espType = record?.caseNameList?.find((type: any) => type?.liftType === 1);
                const jetType = record?.caseNameList?.find((type: any) => type?.liftType === 2);
                let liftTypeName = <></>;
                if (espType && jetType) {
                    liftTypeName = <>
                        {parentLiftType === 1 ? (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>
                            </>) : (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>
                            </>
                        )}
                    </>;
                } else if (jetType) {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>;
                } else {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>;
                }
                return (
                    <div>
                        {liftTypeName}
                    </div >
                )
            },
        },
        {
            title: "Well API#",
            dataIndex: "WellAPI",
            key: "wellAPI",
            sortable: true,
            width: "8%",
        },
        {
            title: "Location",
            dataIndex: "Country",
            key: "country",
            sortable: true,
            width: "8%",
            render: (_: string, record: { country: string, state: string, county: string }) => (
                <>
                    {record?.country}&nbsp;{record?.state && record?.country ? ', ' + record?.state : record?.state ? record?.state : ''}{record?.county && (record?.state || record?.country) ? ', ' + record?.county : record?.county ? record?.county : ''}
                </>
            ),
        },
        {
            title: "Pump type",
            dataIndex: "PumpName",
            key: "pumpName",
            sortable: true,
            width: "8%",
        },
        {
            title: "Updated on",
            dataIndex: "UpdatedOn",
            key: "updatedOn",
            sortable: true,
            width: "8%",
            render: (_: string, record: { updatedOn: string }) => (
                <>
                    {record?.updatedOn && moment(record?.updatedOn).format("DD MMM YYYY")}
                </>
            ),
        },
        {
            title: "Updated by",
            dataIndex: "UpdatedBy",
            key: "updatedBy",
            sortable: true,
            width: "8%",
        }, {
            title: " ",
            dataIndex: "icon",
            key: "icon",
            sortable: false,
            width: "5%",
            render: (_: string, record: { isPinned: boolean }, rowIndex: number) => {
                const dropdownOptions = iconDropdownOptionsForCustomer.map((option: any, index: any) => {
                    if (index === 0) {
                        return {
                            ...option,
                            disabled: pinCount === 5 || record?.isPinned ? true : false,
                        };
                    }
                    return option;
                });

                return (
                    <div className="flex items-center px-0 py-0">
                        <IconDropdown
                            options={dropdownOptions}
                            onSelect={(selectedValue) => handleDropdown(selectedValue, record)}
                            optionHeading={"Options"}
                            dropdownIcon={true}
                            width="320px"
                            rowIndex={rowIndex}
                        />
                    </div>
                );
            },
        },
    ];

export const otherProjects = ({ handleDropdown, pinCount, iconDropdownOptions, handleNavigate }: IOtherProjects) => [
    {
        title: "Project name",
        dataIndex: "ProjectName",
        key: "projectName",
        sortable: true,
        width: "10%",
        render: (_: string, record: { projectName: string; projectID: string }) => (
            <Link to={`/project-details/projectID=${record?.projectID}`} onClick={() => handleNavigate(record)}>
                <p className="text-[14px] font-normal text-primary-400 cursor-pointer truncate hover:underline focus:underline active:underline">
                    {record?.projectName}
                </p>
            </Link>
        ),
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sortable: true,
        width: "10%",
        minwidth: "10rem",
        render: (_: string, record: { projectName: string; projectID: string, status: number }) => {
            return (
                <>
                    {
                        record?.status === 0 ?
                            <div className="border text-center border-gray-200 rounded px-2 py-1 text-gray-200">
                                In progress
                            </div>
                            : record?.status === 1 ?
                                <div className="border flex items-center justify-center text-center border-success-400 rounded px-2 py-1 text-success-400" >
                                    <Success size={12} color="#32D583" className="ml-1 text-success-400 mr-1" />
                                    Acknowledged
                                </div >
                                : record?.status === 2 ?
                                    <div className="border text-center border-lightorange-500 rounded px-2 py-1 text-lightorange-500" >
                                        Need review
                                    </div >
                                    : record?.status === 3 ?
                                        <div className="border text-center border-darkblue-400 rounded px-2 py-1 text-darkblue-400" >
                                            Review In-progress
                                        </div >
                                        : record?.status === 4 &&
                                        <div className="border text-center rounded px-2 py-1 text-primary-400 border-primary-400">
                                            Customer ready
                                        </div>
                    }
                </>
            )
        },
    },
    {
        title: "Well name",
        dataIndex: "WellName",
        key: "wellName",
        sortable: true,
        width: "8%",
    },
    {
        title: "Company name",
        dataIndex: "CompanyName",
        key: "companyName",
        sortable: true,
        width: "8%",
    },
    {
        title: "Type",
        dataIndex: "liftTypeName",
        key: "liftTypeName",
        sortable: true,
        width: "8%",
        minwidth: "10rem",
        render: (_: string, record: { caseNameList: any[]; }) => {
            const parentLiftType = record?.caseNameList?.[0]?.liftType;
            const espType = record?.caseNameList?.find((type: any) => type?.liftType === 1);
            const jetType = record?.caseNameList?.find((type: any) => type?.liftType === 2);
            let liftTypeName = <></>;
            if (espType && jetType) {
                liftTypeName = <>
                    {parentLiftType === 1 ? (
                        <>
                            <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>{" "}
                            <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>
                        </>) : (
                        <>
                            <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>{" "}
                            <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>
                        </>
                    )}
                </>;
            } else if (jetType) {
                liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>;
            } else {
                liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>;
            }
            return (
                <div>
                    {liftTypeName}
                </div >
            )
        },
    },
    {
        title: "Created by",
        dataIndex: "createdBy",
        key: "createdBy",
        sortable: true,
        width: "8%",
    },
    {
        title: "Created on",
        dataIndex: "CreatedOn",
        key: "createdOn",
        sortable: true,
        width: "8%",
        render: (_: string, record: { createdOn: string }) => (
            <>
                {record?.createdOn && moment(record?.createdOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: "Updated by",
        dataIndex: "UpdatedBy",
        key: "updatedBy",
        sortable: true,
        width: "8%",
    },
    {
        title: "Updated on",
        dataIndex: "UpdatedOn",
        key: "updatedOn",
        sortable: true,
        width: "8%",
        render: (_: string, record: { updatedOn: string }) => (
            <>
                {record?.updatedOn && moment(record?.updatedOn).format("DD MMM YYYY")}
            </>
        ),
    },
    {
        title: "Country",
        dataIndex: "Country",
        key: "country",
        sortable: true,
        width: "8%",
    },
    {
        title: "State",
        dataIndex: "State",
        key: "state",
        sortable: true,
        width: "8%",
    },
    {
        title: "Account manager",
        dataIndex: "DALRep",
        key: "dalRep",
        sortable: true,
        width: "8%",
    },
    {
        title: "Unit system",
        dataIndex: "UnitSystem",
        key: "unitSystem",
        sortable: true,
        width: "8%",
    },
    {
        title: " ",
        dataIndex: "icon",
        key: "icon",
        sortable: false,
        width: "5%",
        render: (_: string, record: { isPinned: boolean }, rowIndex: number) => {
            const dropdownOptions = iconDropdownOptions.map((option: any, index: any) => {
                if (index === 0) {
                    return {
                        ...option,
                        disabled: pinCount === 5 || record?.isPinned ? true : false,
                    };
                }
                return option;
            });

            return (
                <div className="flex items-center px-0 py-0">
                    <IconDropdown
                        options={dropdownOptions}
                        onSelect={(selectedValue) => handleDropdown(selectedValue, record)}
                        optionHeading={"Options"}
                        dropdownIcon={true}
                        width="320px"
                        rowIndex={rowIndex}
                    />
                </div>
            );
        },
    },
];
